import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useStore } from "react-redux";
import { RootState, useAppDispatch, useAppSelector } from "@services/redux";
import { clearDraftOrder, updateDraftOrder } from "../redux/order/order.reducer";
import { browserStorage, shouldRestorePersonalDraft, takeStash } from "./group-order.utils";

// MAIN-861: leaving group mode (without going to checkout) puts the
// user's own cart back, so group items never leak into a personal order.
export const useGroupDraftGuard = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const store = useStore<RootState>();
  const groupOrderId = useAppSelector((state) => state.order.draft.groupOrderId);

  useEffect(() => {
    // Read the live value: StrictMode runs this effect twice with the same closure,
    // and the second run must see that the first one already restored the cart.
    const liveGroupOrderId = store.getState().order.draft.groupOrderId;
    if (!shouldRestorePersonalDraft(pathname, liveGroupOrderId)) return;
    const stash = takeStash(browserStorage());
    dispatch(clearDraftOrder());
    if (stash) dispatch(updateDraftOrder(stash));
  }, [dispatch, groupOrderId, pathname, store]);
};
